import * as React from 'react';

import { Group } from './components/Group';
import { Filter } from './components/Filter';

import * as styles from './Filters.css';

interface IFiltersProps {
  dealType?: React.ReactNode;
  offerType?: React.ReactNode;
  roomType?: React.ReactNode;
  posessor?: React.ReactNode;
  bedrooms?: React.ReactNode;
  price?: React.ReactNode;
  area?: React.ReactNode;
  landArea?: React.ReactNode;
  advancedFilters?: React.ReactNode;
  geo?: React.ReactNode;
  savedSearch?: React.ReactNode;
}

export const Filters: React.FC<IFiltersProps> = ({
  dealType,
  offerType,
  roomType,
  posessor,
  bedrooms,
  price,
  area,
  landArea,
  advancedFilters,
  geo,
  savedSearch,
}) => {
  return (
    <div className={styles['container']}>
      <div className={styles['layout']}>
        <Group>
          {[dealType, offerType, roomType, posessor, bedrooms, price, area, landArea, advancedFilters]
            .filter(Boolean)
            .map((filter, index) => (
              <Filter key={`filter_${index}`}>{filter}</Filter>
            ))}
        </Group>
        <Group className={styles['secondary-group']}>
          {geo && <Filter className={styles['geo']}>{geo}</Filter>}
          {savedSearch && (
            <div className={styles['saved-search']} data-name="SaveSearch">
              {savedSearch}
            </div>
          )}
        </Group>
      </div>
    </div>
  );
};
